import { Grid, Card, CardContent, CardMedia, CardActionArea, Typography, Link } from '@material-ui/core'
import { useSelector } from 'react-redux'
import i18n from '../i18n/i18n'
import { pictureUrl } from '../common/pictureUrl'

export const NewNews = () => {
  const articles = useSelector((state) => state.articles)
  if (!articles || Object.keys(articles).length === 0) return null

  return (
    <Card elevation={0} style={{ backgroundColor: 'rgba(25, 133, 161, 0.1)' }}>
      <CardContent className="geCard bigCard">

        <Typography component="h2" variant="h3">
          {i18n.t('news.title_generic')}
        </Typography>

        <Grid container spacing={3}>
          {Object.values(articles)
            .reverse()
            .map((article) => (
              <Grid item xs={12} sm={6} md={3}>
                <Card className="actionArea">
                  <CardActionArea component={Link} underline="none" style={{ color: 'inherit' }} href={`/news/${article.hashid}`}>
                    <CardMedia
                      image={pictureUrl({
                        record_id: article.id,
                        record_type: 'Blog::Article',
                        name: 'picture',
                        created_at: article.picture?.record?.created_at
                      }, 532, 532)}
                      title={article.picture.record.title} />

                    <CardContent>
                      <Typography component="h3" variant="h4" color="primary">
                        {article.title}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
        </Grid>

      </CardContent>
    </Card>
  )
}
